export default "__VITE_ASSET__CE$PJu9j__"